export const dataHooks = {
    tableListHeaderValue: 'tableListHeader-value',
    tableListHeaderCheckbox: 'tableListHeader-checkbox',
    tableListHeaderOptionsContainer: 'tableListHeader-optionsContainer',
    tableListHeaderArrowDescending: 'tableListHeader-arrowDescending',
    tableListHeaderArrowAscending: 'tableListHeader-arrowAscending',
    tableListHeaderInfoIcon: 'tableListHeader-infoIcon',
};
//# sourceMappingURL=constants.js.map